// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__22on_","option":"Login_option__wr_qA","bg":"Login_bg__2oK-C"};